<!-- Start Training Options Section -->
<section class="ecb-web-training-options-section ecb-admin-home-content-section" id="training-section">
  <!-- Page Heading -->
  <div class="ecb-admin-home-page-heading">
    <div>
      <h2>Home Course Content</h2>
      <p>
        Edit homepage section headings and short course card content.
        Click the pencil icon to edit.
      </p>
    </div>
  </div>
  <div class="container">

    <!-- Message -->
    <div *ngIf="message" class="ecb-admin-home-message" [ngClass]="messageType">

      <i class="bi" [ngClass]="messageType === 'success'
          ? 'bi-check-circle-fill'
          : 'bi-exclamation-circle-fill'">
      </i>

      <span>{{ message }}</span>

      <button type="button" (click)="closeMessage()">
        <i class="bi bi-x-lg"></i>
      </button>

    </div>

    <!-- Loading -->
    <div *ngIf="isLoading" class="text-center py-4">

      <i class="pi pi-spin pi-spinner"></i>
      Loading content...

    </div>

    <div class="row g-4" *ngIf="!isLoading">

      <!-- =========================================
           Start Qualifications Card
      ========================================== -->
      <div class="col-12 col-xl-6">

        <article class="ecb-web-training-category-card
                 ecb-web-long-course-card h-100">

          <!-- Floating Icon -->
          <div class="ecb-web-training-category-icon
                   ecb-web-long-course-icon">

            <i class="bi bi-mortarboard-fill"></i>

          </div>

          <!-- Heading -->
          <div class="ecb-web-training-category-header text-center">

            <!-- Qualifications Title -->
            <ng-container *ngTemplateOutlet="
                editableField;
                context: {
                  code: 'QUALIFICATIONS',
                  field: 'title',
                  kind: 'heading'
                }
              ">
            </ng-container>

            <!-- Qualifications Subtitle -->
            <ng-container *ngTemplateOutlet="
                editableField;
                context: {
                  code: 'QUALIFICATIONS',
                  field: 'subTitle',
                  kind: 'subtitle'
                }
              ">
            </ng-container>

            <!-- Qualifications Description -->
            <ng-container *ngTemplateOutlet="
                editableField;
                context: {
                  code: 'QUALIFICATIONS',
                  field: 'description',
                  kind: 'description'
                }
              ">
            </ng-container>

          </div>




          <!-- Qualifications Grid Preview -->
          <!-- Start Qualifications 2 x 2 Grid -->
          <div class="row g-3 ecb-web-short-option-grid">

            <div class="col-6  ecb-admin-qualification-disabled" *ngFor="let slot of qualificationSlots">

              <!-- Assigned Qualification -->
              <article *ngIf="slot.tag as tag; else emptyQualification" class="ecb-web-short-option-card h-100">

                <!-- Qualification Icon -->
                <div class="ecb-web-short-option-icon" [ngClass]="slot.iconClass">

                  <i [ngClass]="slot.icon"></i>

                </div>

                <!-- Tag Name -->
                <h4 class="ecb-web-long-option-title">
                  {{ tag.tagName }}
                </h4>

                <!-- Tag Description -->
                <p>
                  {{ tag.plainDescription }}
                </p>

                <!-- View Courses Button -->
                <button type="button" disabled class="btn ecb-web-short-option-button ecb-web-long-option-button">

                  <span>View Courses</span>

                  <i class="bi bi-arrow-right"></i>

                </button>

              </article>

              <!-- Empty Qualification Position -->
              <ng-template #emptyQualification>

                <article class="ecb-web-short-option-card
               ecb-admin-empty-qualification h-100">

                  <div class="ecb-admin-empty-qualification-icon">
                    <i class="bi bi-plus-circle"></i>
                  </div>

                  <h4>Not Assigned</h4>

                  <p>
                    {{ slot.position.replace('_', ' ') }}
                  </p>

                  <span class="ecb-admin-empty-qualification-text">
                    Assign a tag from Tag Management
                  </span>

                </article>

              </ng-template>

            </div>

          </div>
          <!-- End Qualifications 2 x 2 Grid -->

        </article>

      </div>
      <!-- End Qualifications Card -->


      <!-- =========================================
           Start Short Courses Card
      ========================================== -->
      <div class="col-12 col-xl-6">

        <article class="ecb-web-training-category-card
                 ecb-web-short-course-card h-100">

          <!-- Floating Icon -->
          <div class="ecb-web-training-category-icon
                   ecb-web-short-course-icon">

            <i class="bi bi-journal-text"></i>

          </div>

          <!-- Heading -->
          <div class="ecb-web-training-category-header text-center">

            <!-- Short Courses Title -->
            <ng-container *ngTemplateOutlet="
                editableField;
                context: {
                  code: 'SHORT_COURSES',
                  field: 'title',
                  kind: 'heading'
                }
              ">
            </ng-container>

            <!-- Short Courses Subtitle -->
            <ng-container *ngTemplateOutlet="
                editableField;
                context: {
                  code: 'SHORT_COURSES',
                  field: 'subTitle',
                  kind: 'subtitle'
                }
              ">
            </ng-container>

            <!-- Short Courses Description -->
            <ng-container *ngTemplateOutlet="
                editableField;
                context: {
                  code: 'SHORT_COURSES',
                  field: 'description',
                  kind: 'description'
                }
              ">
            </ng-container>

          </div>




          <!-- Admin preview: matches the public new-ecb layout -->
          <div class="new-ecb-short-category-layout ecb-admin-new-short-preview">

            <div class="new-ecb-short-option-grid">

              <div class="new-ecb-short-option-column"
                   *ngFor="let card of shortCourseCards; trackBy: trackShortCourseCard">

                <article class="new-ecb-short-option-card">

                  <div class="new-ecb-short-option-icon" [ngClass]="card.iconClass">
                    <i [ngClass]="card.icon"></i>
                  </div>

                  <!-- Editable title: uses the existing shared template -->
                  <ng-container *ngTemplateOutlet="editableField; context: {
                      code: card.code, field: 'title', kind: 'cardTitle'
                  }"></ng-container>

                  <!-- Editable description -->
                  <ng-container *ngTemplateOutlet="editableField; context: {
                      code: card.code, field: 'description', kind: 'cardDescription'
                  }"></ng-container>

                  <!-- Preview-only button; never navigates -->
                  <button type="button"
                          disabled
                          class="new-ecb-short-option-button ecb-admin-preview-disabled-button"
                          [ngClass]="card.buttonClass">
                    <span>{{ card.buttonText }}</span>
                    <i class="bi bi-arrow-right"></i>
                  </button>

                </article>

              </div>
            </div>

            <!-- HSR inline editing, matching the other admin cards. -->
            <div class="new-ecb-hsr-centre-wrapper">
              <div class="new-ecb-hsr-centre-card ecb-admin-hsr-centre-preview">

                <div class="new-ecb-hsr-centre-icon" *ngIf="!isHsrEditing()">
                  <i class="bi bi-shield-check"></i>
                </div>

                <!-- HSR title + pencil; turns into input on click -->
                <div class="new-ecb-hsr-edit-field new-ecb-hsr-edit-title"
                     [class.new-ecb-hsr-field-active]="isEditing('HSR', 'title')"
                     *ngIf="!isHsrEditing() || isEditing('HSR', 'title')">
                  <ng-container *ngTemplateOutlet="editableField; context: {
                    code: 'HSR', field: 'title', kind: 'cardTitle', fallback: 'HSR'
                  }"></ng-container>
                </div>

                <!-- HSR subtitle + pencil -->
                <div class="new-ecb-hsr-edit-field new-ecb-hsr-edit-subtitle"
                     [class.new-ecb-hsr-field-active]="isEditing('HSR', 'subTitle')"
                     *ngIf="!isHsrEditing() || isEditing('HSR', 'subTitle')">
                  <ng-container *ngTemplateOutlet="editableField; context: {
                    code: 'HSR', field: 'subTitle', kind: 'subtitle', fallback: 'Training'
                  }"></ng-container>
                </div>

                <!-- HSR description + pencil -->
           <!--      <div class="new-ecb-hsr-edit-field new-ecb-hsr-edit-description"
                     [class.new-ecb-hsr-field-active]="isEditing('HSR', 'description')"
                     *ngIf="!isHsrEditing() || isEditing('HSR', 'description')">
                  <ng-container *ngTemplateOutlet="editableField; context: {
                    code: 'HSR', field: 'description', kind: 'cardDescription'
                  }"></ng-container>
                </div>
 -->
                <div class="new-ecb-hsr-centre-action" *ngIf="!isHsrEditing()">
                  View Courses <i class="bi bi-arrow-right"></i>
                </div>

              </div>
            </div>

          </div>
          <!-- End admin short course preview -->

          <!-- Shown only if the HSR content record is not in the API response. -->
          <p *ngIf="!getContent('HSR')" class="ecb-admin-hsr-missing">
            HSR is not configured in Home Course Content yet. Add the
            contentCode 'HSR' record before editing its text.
          </p>

        </article>

      </div>
      <!-- End Short Courses Card -->

    </div>

  </div>

</section>
<!-- End Training Options Section -->


<!-- ====================================================
     REUSABLE INLINE EDIT FIELD
===================================================== -->
<ng-template #editableField let-code="code" let-field="field" let-kind="kind" let-fallback="fallback">

  <div class="ecb-admin-inline-field" [ngClass]="'ecb-admin-inline-' + kind">

    <!-- Normal Display -->
    <ng-container *ngIf="!isEditing(code, field)">

      <div class="ecb-admin-inline-display">

        <!-- Main Heading -->
        <h3 *ngIf="kind === 'heading'">
          {{ getFieldValue(code, field) || fallback || '—' }}
        </h3>

        <!-- Subtitle -->
        <h5 *ngIf="kind === 'subtitle'">
          {{ getFieldValue(code, field) || fallback || '—' }}
        </h5>

        <!-- Section Description -->
        <p *ngIf="kind === 'description'" class="ecb-admin-preserve-lines">
          {{ getFieldValue(code, field) || fallback || '—' }}
        </p>

        <!-- Card Title -->
        <h4 *ngIf="kind === 'cardTitle'">
          {{ getFieldValue(code, field) || fallback || '—' }}
        </h4>

        <!-- Card Description -->
        <p *ngIf="kind === 'cardDescription'" class="ecb-admin-preserve-lines">

          {{ getFieldValue(code, field) || fallback || '—' }}

        </p>

        <!-- Edit Pencil -->
        <!-- Edit / Saved Button -->
        <!-- Edit / Saved Icon -->
        <span class="ecb-admin-inline-edit-icon" [ngClass]="{
    'ecb-admin-inline-saved-icon': isRecentlySaved(code, field),
    'ecb-admin-inline-disabled-icon':
      !!editingKey || isSaving || !getContent(code)
  }" (click)="!editingKey && !isSaving && getContent(code) && !isRecentlySaved(code, field)
    ? startEdit(code, field)
    : null" [title]="isRecentlySaved(code, field) ? 'Saved successfully' : 'Edit content'">

          <!-- Success Icon -->
          <i *ngIf="isRecentlySaved(code, field)" class="bi bi-check-circle-fill">
          </i>

          <!-- Edit Icon -->
          <i *ngIf="!isRecentlySaved(code, field)" class="fa fa-pencil">
          </i>

        </span>

      </div>

    </ng-container>


    <!-- Edit Mode -->
    <ng-container *ngIf="isEditing(code, field)">

      <div class="ecb-admin-inline-editor">

        <!-- Input for Titles / Subtitles -->
        <input *ngIf="field !== 'description'" type="text" class="form-control form-control-sm" [(ngModel)]="editValue"
          [maxlength]="field === 'title' ? 30 : 50" [disabled]="isSaving" placeholder="Enter text">  
 
        <input *ngIf="field === 'description'" class="form-control form-control-sm" [(ngModel)]="editValue"
          [disabled]="isSaving" [maxlength]="100" placeholder="Enter description">  

        <!-- Save / Cancel -->
        <div class="ecb-admin-inline-actions">

          <button type="button" class="ecb-admin-inline-cancel-btn" [disabled]="isSaving" (click)="cancelEdit()">

            <i class="bi bi-x"></i>
            Cancel

          </button>

          <button type="button" class="ecb-admin-inline-save-btn" [disabled]="isSaving"
            (click)="saveField(code, field)">

            <i class="bi" [ngClass]="isSaving
                ? 'bi-arrow-repeat'
                : 'bi-check-lg'">
            </i>

            {{ isSaving ? 'Saving...' : 'Save' }}

          </button>

        </div>

      </div>

    </ng-container>

  </div>

</ng-template>